import $ from 'jquery';
export default class RedirectToPage {
    static $elements = $('.js__redirect-to-page');
    static init() {
        if (!this.$elements.length) {
            return;
        }
        this.$elements.each((index, element) => {
            const redirectPage = $(element).data('redirectPage');
            if (redirectPage) {
                window.location.assign(redirectPage);
            }
        });
    }
}
